// plugins to Deactivate/hide from Dated Course Templates 
export const pluginsToDeactivate = [
  "d588c170-5f60-11ea-be6d-97aa63e758bc",
  "d57bc920-5f60-11ea-be6d-97aa63e758bc",
  "d55862a0-5f60-11ea-be6d-97aa63e758bc",
];